<template>
  <div>
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        :title="pui.pkid > 0 ? '编辑':'新建'"
        class="customer-edit"
        width="900px"
        top="10vh"
        @close="$reset('form')">
      <el-form
          ref="form"
          v-loading="contentLoading"
          :model="pui"
          :rules="ruleValidate"
          class="form"
          label-width="150px">
        <div class="vm-separate">
          <el-form-item label="产品名称">
            <el-input v-model="pui.productName" placeholder="请输入"/>
          </el-form-item>
          <el-form-item label="产品型号">
            <el-input v-model="pui.productModel" placeholder="请输入"/>
          </el-form-item>
        </div>
        <div class="vm-separate">
          <el-form-item label="申请类型">
            <el-select v-model="pui.applyType" clearable placeholder="请选择">
              <el-option
                  v-for="item in applyTypes"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"/>
            </el-select>
          </el-form-item>
          <el-form-item label="预估受影响总量">
            <el-input v-model="pui.affectQuantity" placeholder="请输入"/>
          </el-form-item>
        </div>
        <el-form-item label="批次和生产日期">
          <el-input v-model="pui.productionDateAndBatch" type="textarea" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="缺陷情况描述">
          <el-input v-model="pui.defectDesc" type="textarea" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="缺陷可能导致的后果">
          <el-input v-model="pui.defectResult" type="textarea" placeholder="请输入"/>
        </el-form-item>
        <el-form-item label="生产缺陷的原因">
          <el-input v-model="pui.defectReason" type="textarea" placeholder="请输入"/>
        </el-form-item>
        <div>
          <div
              style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
            附件
          </div>
          <div>
            <el-upload
                action=""
                multiple
                :http-request="submitUpload"
                :show-file-list="false"
                :disabled="uploadLoading"
                style="display: inline-block; float: left; margin: 5px;">
              <el-button type="primary" plain>
                <i class="el-icon-upload el-icon--right"/>
                附件上传
              </el-button>
            </el-upload>
          </div>
          <el-table
              v-if="pui.attachments"
              ref="payData"
              :data="pui.attachments">
            <el-table-column type="index" align="center" label="行号"/>
            <el-table-column prop="fileName" align="center" label="图片">
              <template slot-scope="scope">
                <el-image
                    style="width: 50px; height: 50px;margin-right: 10px"
                    :src="scope.row.imgUrl"
                    :preview-src-list="imgUrls"/>
              </template>
            </el-table-column>
            <el-table-column prop="fileName" align="center" label="附件描述">
              <template slot-scope="scope">
                <el-input
                    v-model="scope.row.fileName"
                    class="tabInput"
                    style="width: 400px;margin: 0 auto;text-align: center"/>
              </template>
            </el-table-column>
            <el-table-column label="操作" align="center" width="60" class-name="vm-table_operate">
              <template slot-scope="scope">
                <el-button type="danger" @click="fileDelete(scope.row,scope.$index)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      <span slot="footer">
        <el-button @click="dialogVisible=false">取消</el-button>
        <el-button :loading="submitLoading" type="primary" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import EmployeeSelect from "@/views/information/Employee/EmployeeSelect";
  import constant from "@/util/constant";
  import Employee2Select from "@/views/information/Employee/Employee2Select";
  import loginUtil from "@/util/loginUtil";

  export default {
    name:"PUIEdit",
    components: {},
    data() {
      return {
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        uploadLoading: false,
        constant,
        applyTypes:constant.toSelect(constant.applyType),
        approveResults:constant.toSelect(constant.approveResult),
        files: [],
        imgUrls: [],
        selection: [],
        index: [],
        actionUrl: window.config.basicServerHttpUrl + "file/upload",
        pui: {
          pkid: "",
          puiNo: "",
          applyType: "",
          applicantId: "",
          applicantName: "",
          applicantDepartmentName: "",//申请部门
          affectQuantity: "",
          productionDateAndBatch: "",
          defectDesc: "",
          defectResult: "",
          defectReason: "",
          puiProcessList:[],
          attachments:[],
        },
        tableData:[
          {pkid:0,masterId:0,isSelected:false,departmentNo:10,departmentName:"申请部门负责人",releaseTime:"",approverId:0,approverName:"",approveResult:"",approveTime:""},
          {pkid:0,masterId:0,isSelected:false,departmentNo:20,departmentName:"研发",releaseTime:"",approverId:0,approverName:"",approveResult:"",approveTime:""},
          {pkid:0,masterId:0,isSelected:false,departmentNo:30,departmentName:"技术部",releaseTime:"",approverId:0,approverName:"",approveResult:"",approveTime:""},
          {pkid:0,masterId:0,isSelected:false,departmentNo:40,departmentName:"质量部",releaseTime:"",approverId:0,approverName:"",approveResult:"",approveTime:""},
          {pkid:0,masterId:0,isSelected:false,departmentNo:50,departmentName:"客户质量管理部",releaseTime:"",approverId:0,approverName:"",approveResult:"",approveTime:""},
          {pkid:0,masterId:0,isSelected:false,departmentNo:60,departmentName:"售后服务部",releaseTime:"",approverId:0,approverName:"",approveResult:"",approveTime:""},
          {pkid:0,masterId:0,isSelected:false,departmentNo:70,departmentName:"其他部门",releaseTime:"",approverId:0,approverName:"",approveResult:"",approveTime:""},
          {pkid:0,masterId:0,isSelected:false,departmentNo:80,departmentName:"总经理",releaseTime:"",approverId:0,approverName:"",approveResult:"",approveTime:""},
          {pkid:0,masterId:0,isSelected:false,departmentNo:90,departmentName:"董事长",releaseTime:"",approverId:0,approverName:"",approveResult:"",approveTime:""},
        ],
        ruleValidate: {
          // puiNO: {required: true, message: "不能为空",trigger: "blur"},
        },
      };
    },
    methods: {
      open(id) {
        this.pui.pkid = id;
        console.log(id);
        this.dialogVisible = true;
        if(id>0) {
          this.$nextTick(() => {
            this.getData();
          });
        }else {
          this.getNode();
        }
      },
      select(selection) {
        this.selection = selection;
        this.index = [];
        for (let item of this.selection) {
          this.index.push((item.departmentNo/10)-1);
        }
      },
      submitUpload(params) {
        this.uploadLoading = true;
        let formData = new FormData(); //  用FormData存放上传文件
        formData.append("files", params.file);
        formData.append("Authorization", loginUtil.getToken());
        this.$http
          .post("basic", "file/batch/0", formData)
          .then((res) => {
            this.uploadLoading = false;
            // this.saveAttachments(res.data.attachments, 0);
            const fileInfo = res.data.attachments[0];
            console.log(fileInfo);
            this.pui.attachments.push({
              fileName: fileInfo.fileName,
              filePath: "/attached/file/" + fileInfo.filePath,
              note: "",
            });
            this.pui.attachments.forEach(row=>{
              if(row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              }else {
                row.imgUrl = "http://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
            this.$message.success("上传成功");
          })
          .catch(() => {
            this.uploadLoading = false;
            this.$message.error("上传失败");
          });
      },
      selectEmployee(row) {
        this.pui.applicantId = row.employeeID;
        this.pui.applicantName = row.employeeName;
        this.pui.applicantDepartmentName = row.departmentName;
      },
      selectDealMan(index,row) {
        this.tableData[index].approverId = row.employeeID;
        this.tableData[index].approverName = row.employeeName;
      },
      getData() {
        this.$http
          .get("basic", `pui/${this.pui.pkid}`)
          .then(resp => {
            this.pui = resp;
            this.pui.attachments.forEach(row=>{
              if(row.filePath.includes("common")) {
                row.imgUrl = window.config.basicServerHttpUrl + "file/download?uuid=" + row.filePath + "&name=" + row.fileName;
                this.imgUrls.push(row.imgUrl);
              }else {
                row.imgUrl = "http://emes.stepelectric.com" + row.filePath;
                this.imgUrls.push(row.imgUrl);
              }
            });
            // if (resp.puiProcessList.length>0) {
            //   this.tableData = resp.puiProcessList;
            //   this.$nextTick(() => {
            //     this.tableData.forEach(item => {
            //       if (item.isSelected) {
            //         this.selection.push(item);
            //         this.$refs.table.toggleRowSelection(item,true);
            //       }
            //     });
            //   });
            //   this.$nextTick(() => {
            //     for (let item of this.selection) {
            //       this.index.push((item.departmentNo/10)-1);
            //     }
            //   });
            // }
          });
      },
      // getFullUrl(row) {
      //   // `file/download/${row.filePath}/${row.pictureName}`
      //   return  window.config.basicServerUrl + "file/download?uuid=" + row.filePath+"&name=" + row.pictureName;
      // },
      getNode() {
        this.$http
          .get("basic", "pui/getPuiNo")
          .then(resp => {
            this.pui.puiNo = resp;
          });
      },
      handlerError(err, file, fileList) {
        console.log(file);
        console.log(fileList);
        alert(err);
      },
      // beforeAvatarUpload(file) {
      //   return this.$confirm(`确定移除 ${ file.name }？`);
      // },
      handleSuccess(response, file, fileList) {
        file.path = response;
        this.files = fileList;
        let object ={
          fileName:file.path.originalName,
          filePath:file.path.fullPath,
        };
        this.pui.attachments.push(object);
      },
      handleRemove(file, fileList) {
        this.files = fileList;
      },
      getArrDifference(arr1) {
        let arr2= [0,1,2,3,4,5,6,7,8];
        return arr1.concat(arr2).filter(function(v, i, arr) {
          return arr.indexOf(v) === arr.lastIndexOf(v);
        });
      },
      handleSubmit() {
        // if (this.selection.length>0) {
        //   // 选中
        //   for (let index of this.index) {
        //     this.tableData[index].isSelected = true;
        //   }
        //   //取消选中
        //   let newList =  this.getArrDifference(this.index);
        //   for (let index of newList) {
        //     this.tableData[index].isSelected = false;
        //   }
        // }
        // this.pui.puiProcessList = this.tableData;
        if(this.pui.pkid>0) {
          this.handleSubmitUpData();
        }else {
          this.handleSubmitSave();
        }
      },
      handleSubmitUpData() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .put("basic", "pui",  this.pui)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
      handleSubmitSave() {
        this.$refs.form.validate(valid => {
          if (valid) {
            this.submitLoading = true;
            this.$http
              .post("basic", "pui", this.pui)
              .then(() => {
                this.submitLoading = false;
                this.dialogVisible = false;
                this.$emit("save-success");
                this.$message.success("保存成功");
              })
              .catch(() => {
                this.submitLoading = false;
              });
          }
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
</style>
